var app = angular.module("leonardo");

var AccountSelectDialog = function($scope, AccountService) {
  $scope.accounts = angular.copy(AccountService.getCollection());
  $scope.accountsIds = [];
  $scope.accountsSelected = [];
  $scope.userComboListVisible = false;


  $scope.toggleUserComboList = function() {
    $scope.userComboListVisible = !$scope.userComboListVisible;
  };

  $scope.addUser = function(account) {
    if (_.contains($scope.accountsIds, account.id)) {
      return;
    }
    $scope.accountsIds.push(account.id);
    $scope.accountsSelected.push(account);
    $scope.toggleUserComboList();
  };

  $scope.removeUser = function(index) {
    $scope.accountsIds.splice(index, 1);
    $scope.accountsSelected.splice(index, 1);
  };

  $scope.getAccountUserClasses = function(account) {
    var classes = [];
    if (_.contains($scope.accountsIds, account.id)) classes.push('active');
    return classes;
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.accountsIds.length == 0) return;
    $scope.confirm($scope.accountsIds);
  };
};

app.controller('AccountSelectDialog', ['$scope', 'AccountService', AccountSelectDialog]);
